export const MakePredictionButton: React.FunctionComponent<{onClick: ()=>void}> = ({onClick}) => {
  return (
    <div role="button" className="btn btn-make-prediction my-3" onClick={() => onClick()}>
      Make Prediction and Enter
    </div>
  );
}